import React, {Fragment, useContext} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import UiSwitch from "../../PageLayout/UiSwitch";
import {jobCartItemInterface} from "./jobEditInterfaces";
import {getCurrencySymbol} from "../../../utilities";
import JobEditPopupContext from "./JobEditPopupContext";
import {updateCartItems} from "./jobEditPopupFunctions";


const JobEditPopupCartItem = (props) => {

  const {jobCartItem, jobCartItems, dispatch} = props;

  const {iframeElement} = useContext(JobEditPopupContext);

  const toggleCheckJobCartItem = () => {
    updateCartItems([jobCartItem], jobCartItems, "isRemoved", !jobCartItem.isRemoved, dispatch, iframeElement)
  }

  // const loading = jobEditPopupIframeLoading || jobEditPopupIframeWaiting;
  const loading = false;

  return (
    <li key={jobCartItem.id} className="mb-1 job-board-edit-popup__grid-row">
      <div className="border-box flex flex--bottom flex--start h-3 job-board-edit-popup__grid-cell pl-05 pr-05 pt-05">
        <UiSwitch onClick={toggleCheckJobCartItem}
                  checked={!jobCartItem.isRemoved}/>
      </div>
      <div className="flex flex--bottom flex--start h-3 text-overflow pb-05 pt-05 pl-15 pr-1 job-board-edit-popup__grid-cell border-box">
        {jobCartItem.cartFeature.partName}{jobCartItem.cartFeature.sku ? " (sku: " + jobCartItem.cartFeature.sku + ")" : null}
      </div>
      <div className="flex flex--bottom flex--bottom h-3 pb-05 pt-05 pl-1 pr-1 job-board-edit-popup__grid-cell border-box">
        {((jobCartItem.units || jobCartItem.unit) === "No Quantity") ? null : (
          <Fragment>
            {jobCartItem.units || jobCartItem.unit ? (jobCartItem.units || jobCartItem.unit) + ": " : ""}
            {jobCartItem.quantity}
          </Fragment>
        )}
      </div>
      <div className="flex flex--bottom flex--end h-3 pb-05 pt-05 pl-1 job-board-edit-popup__grid-cell border-box">
        {loading
          ? <div className="ui-loader ui-loader--small"/>
          : getCurrencySymbol(jobCartItem.currency) + jobCartItem.calculatedCost}
      </div>
    </li>
  )
};

JobEditPopupCartItem.propTypes = {
  jobCartItem: PropTypes.shape(jobCartItemInterface).isRequired,
}

const mapStateToProps = (store) => {
  const {jobCartItems} = store.jobEditPopupState;
  return {
    jobCartItems,
    // jobEditPopupIframeLoading,
    // jobEditPopupIframeWaiting,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatch
});

export default (
  connect(mapStateToProps, mapDispatchToProps)(JobEditPopupCartItem)
)
